import * as React from 'react';
import { RootStore, withInjectedRootStore } from 'providers';
import { Brands } from 'enums';
import { useTranslation } from 'react-i18next';
import { Footer as WixUiFooter } from '@wix/wix-ui-premium-purchase';
import { Text, TextButton } from 'wix-style-react';
import { FooterLink, FooterLinkCode } from './FooterLink';

interface FooterProps {
  rootStore: RootStore;
}

const CopyrightText = ({ brand }) => {
  const { t } = useTranslation();
  return (
    <Text size='small' weight='normal' dataHook='copyright-text'>
      {t(
        brand === Brands.WIX ? 'footer.copyright' : 'footer.editorx.copyright',
      )}
    </Text>
  );
};

const BackToTopButtonLink = ({ scrollToTop }) => {
  const { t } = useTranslation();
  return (
    <TextButton
      size='small'
      skin='dark'
      onClick={scrollToTop}
      dataHook='footer-scroll'
    >
      {t('footer.back_to_top')}
    </TextButton>
  );
};

const FooterComp: React.FC<FooterProps> = ({ rootStore }) => {
  const {
    appContext: { brand },
    scrollToTop,
    isAnonymous,
  } = rootStore.appStore;

  return (
    <WixUiFooter
      brand={brand}
      isLoggedIn={!isAnonymous}
      CopyrightText={() => <CopyrightText brand={brand} />}
      FirstButtonLink={() => (
        <FooterLink brand={brand} code={FooterLinkCode.TERMS_OF_USE} />
      )}
      SecondButtonLink={() => (
        <FooterLink brand={brand} code={FooterLinkCode.PRIVACY} />
      )}
      ThirdButtonLink={() => (
        <FooterLink brand={brand} code={FooterLinkCode.CONTACT_US} />
      )}
      BackToTopButtonLink={() => (
        <BackToTopButtonLink scrollToTop={scrollToTop} />
      )}
    />
  );
};

export const Footer = withInjectedRootStore(FooterComp);
